import React, { forwardRef } from 'react';
import { Query, Mutation } from 'react-apollo';
import gql from 'graphql-tag';
import classNames from 'classnames';

import Tippy from '../utils/Tippy';
import Icon, { ThumbsUpIcon } from '../utils/icons';

const CHAT_QUERY = gql`
  query Chat($id: Int!) {
    chat(id: $id) {
      id
      status
      messages {
        id
        approved
        text
        sender
        source
        sent
      }
      created
    }
  }
`;

const APPROVE_MESSAGE_MUTATION = gql`
  mutation approveMessage($message: Int!) {
    approveMessage(message: $message) {
      id
      __typename
      approved
    }
  }
`;

const ApproveMessageButton = ({ chatId, messageId }) => (
  <Mutation mutation={APPROVE_MESSAGE_MUTATION}>
    {(approveMessage, { loading, error, data }) => (
      <div
        className="chat-message-action chat-message-action-approve"
        onClick={e => {
          e.preventDefault();

          if (!loading) {
            approveMessage({
              variables: { message: messageId },
              optimisticResponse: {
                __typename: 'Mutation',
                approveMessage: {
                  id: messageId,
                  __typename: 'Message',
                  approved: true,
                },
              },
            });
          }
        }}
      >
        <Icon icon={ThumbsUpIcon} />
      </div>
    )}
  </Mutation>
);

export default ApproveMessageButton;
